<template>
  <div>
    <Header modeType="2" />
    <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">汇团团 社群团购小程序</div>
        <div class="line" />
        <div class="desc">
          帮助货源多的供货方，拓宽销路；帮助人脉广的团长，赚取佣金
          <!-- <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div> -->
        </div>
        <div class="btn-wrap">
          <div class="btn1" @click="openLoginModal">免费试用</div>
          <div class="btn" @click="openModal">立即咨询</div>
        </div>
      </div>
    </div>
    <div class="service">
      <div class="sk-block-title1">
        <div class="title1">您是否也为在以下痛点困扰？</div>
      </div>
      <div class="content">
        <div class="service_box">
          <img src="@/assets/images/QcAssociation/box1.png" alt="" />
          <div class="box_title">流量少</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcAssociation/box2.png" alt="" />
          <div class="box_title">货源缺</div>
        </div>
        <div class="service_box">
          <img src="@/assets/images/QcAssociation/box3.png" alt="" />
          <div class="box_title">销路单一</div>
        </div>
      </div>
    </div>
    <div class="improve" style="height: 742px">
      <div class="sk-block-title1">
        <div class="title1">卖货难题各个击破</div>
        <!-- <div class="sub-title1">提供多行业优质供应链，方便在线比价，并支持商品一键入库，商品自动同步销售端</div> -->
      </div>
      <div class="content">
        <div class="content_left">
          <div
            class="left_item"
            :class="{ left_item1: tooItem == '1' }"
            @click="checkBg('1')"
          >
            <div v-if="tooItem == '1'" class="item_line"></div>
            <div v-if="tooItem == '1'" class="item_box">
              <p>获流量</p>
              <ul class="left_text">
                <li><span>社群跟团分享，营造接龙火爆气氛</span></li>
                <li><span>多人拼团商品低价，吸引流量</span></li>
              </ul>
            </div>
            <span v-if="tooItem != '1'">获流量</span>
          </div>
          <div
            class="left_item"
            :class="{ left_item1: tooItem == '2' }"
            @click="checkBg('2')"
          >
            <div v-if="tooItem == '2'" class="item_line"></div>
            <div v-if="tooItem == '2'" class="item_box">
              <p>找货源</p>
              <ul class="left_text">
                <li><span>官方供应链资源支撑，品牌直供、正品保障</span></li>
                <li>
                  <span>优质供货团长一手货源入驻，高额利润，独家资源</span>
                </li>
              </ul>
            </div>
            <span v-if="tooItem != '2'">找货源</span>
          </div>
          <div
            class="left_item"
            :class="{ left_item1: tooItem == '3' }"
            @click="checkBg('3')"
          >
            <div v-if="tooItem == '3'" class="item_line"></div>
            <div v-if="tooItem == '3'" class="item_box">
              <p>拓销路</p>
              <ul class="left_text">
                <li><span>全平台团长帮卖，实现业绩增长</span></li>
                <li><span>一键复制帮卖，推荐赚佣金</span></li>
              </ul>
            </div>
            <span v-if="tooItem != '3'">拓销路</span>
          </div>
        </div>
        <div class="content_right">
          <img
            v-if="tooItem == '1'"
            src="@/assets/images/QcAssociation/content_right1.png"
            alt=""
          />
          <img
            v-if="tooItem == '2'"
            src="@/assets/images/QcAssociation/content_right2.png"
            alt=""
          />
          <img
            v-if="tooItem == '3'"
            src="@/assets/images/QcAssociation/content_right3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="service" style="height: 1120px">
      <div class="sk-block-title1">
        <div class="title1">
          供货团长，通过帮卖裂变和社群自买，实现增客流和促成交！
        </div>
      </div>
      <div class="content1"></div>
    </div>
    <div class="saveMoney">
      <div class="sk-block-title1">
        <div class="title1">想赚钱，想省钱都来汇团团</div>
      </div>
      <div class="content1"></div>
    </div>
    <Contact :infoSources="'汇通数科官网-汇团团'" />
    <TryModal
      v-if="visible"
      :visible="visible"
      info-sources="社群分销"
      @cancel="modalClose"
    />
    <LoginModal
        v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'5'"
        />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo";
import TryModal from "@/components/TryModal";
import Contact from "@/components/Contact";
import LoginModal from '@/components/LoginModal'

export default {
  metaInfo: metaInfo.QcAssociation,
  components: {
    Header,
    Footer,
    TryModal,
    Contact,
    LoginModal
  },
  data() {
    return {
      visible: false,
      toolBg: require("@/assets/images/QcCashier/tool1.png"),
      tooItem: "1",
      showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
    };
  },
  mounted() {},
  methods: {
    // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
    checkBg(item) {
      this.tooItem = item;
      this.toolBg = "@/assets/images/QcCashier/tool" + item + ".png";
    },
    openModal: function () {
      this.visible = true;
    },
    modalClose: function (data) {
      this.visible = data;
    },
  },
};
</script>

<style lang="less" scoped>
.left_text{
    margin-top: 20px;
}
.improve {
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  height: 742px;
  background: #f9fffb;
  .content {
    margin-top: 40px;
    width: 1200px;
    height: 544px;
    background: #ffffff;
    box-shadow: 0px 2px 21px 0px rgba(61, 77, 100, 0.12);
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    .content_right {
      width: 714px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 544px;
      img {
        width: 668px;
        height: 454px;
      }
    }
    .content_left {
      background: url("~@/assets/images/QcAssociation/content_left.png")
        no-repeat center;
      background-size: 486px 544px;
      width: 486px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .left_item {
        width: 455px;
        height: 73px;
        box-shadow: 0px 2px 4px 0px rgba(34, 81, 32, 0.1);
        border-radius: 4px;
        text-align: left;
        margin-top: 25px;
        padding: 18px 0px 22px 23px;
        cursor: pointer;
        span {
          width: 72px;
          height: 33px;
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
        }
      }
      .left_item1 {
        width: 455px;
        height: 151px;
        margin-top: 20px;
        background-color: #ffffff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.17);
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 0px;
        .item_line {
          width: 8px;
          height: 151px;
          background: #60bc66;
          border-radius: 1px;
        }
        .item_box {
          width: 447px;
          height: 151px;
          background-color: #ffffff;
          display: flex;
          flex-direction: column;
          p {
            width: 72px;
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 74px;
            margin-left: 15px;
          }
          ul {
          }
          li {
            list-style: disc;
            color: #05aa5c;
            height: 25px;
            line-height: 25px;
            margin-left: 25px;
            margin-bottom: 14px;
            span {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
    }
  }
}
.service {
  height: 462px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content {
    width: 1200px;
    padding: 57px 0;
    display: flex;
    flex-direction: row;
    height: 255px;
    justify-content: space-between;
    .service_box {
      width: 210px;
      height: 220px;
      background: #fafafa;
      border-radius: 17px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 116px;
        height: 116px;
      }
      .box_title {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
        margin-top: 15px;
      }
      .box_text {
        // width: 192px;
        height: 72px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
      }
    }
  }
  .content1 {
    width: 1200px;
    height: 898px;
    background: url("~@/assets/images/QcAssociation/content1.png") no-repeat
      center;
    background-size: 1149px 898px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 52px;
  }
}
.saveMoney {
  height: 710px;
  background: #f8fbfd;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content1 {
    width: 1200px;
    height: 491px;
    background: url("~@/assets/images/QcAssociation/content2.png") no-repeat
      center;
    background-size: 1149px 491px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 49px;
  }
}
.num {
  font-size: 36px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #4851fe;
}
/deep/ i.el-icon-arrow-left {
  font-size: 35px;
  font-weight: 600;
}
/deep/ i.el-icon-arrow-right {
  font-size: 35px;
  font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,
button.el-carousel__arrow.el-carousel__arrow--right {
  width: 50px;
  height: 86px;
  border-radius: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
  width: 50px;
  height: 86px;
  border-radius: 0px;
  background-color: rgba(0, 0, 0, 0.4);
}

.custom {
  height: 662px;
  background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat
    center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    background: rgba(255, 255, 255, 0.5);
    // background: #FFFFFF;
    // opacity: 0.55;
    // border-radius: 8px;
    margin-top: 42px;
    height: 439px;
    .custom_item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0 150px;
      .cutom_box {
        width: 260px;
        height: 89px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 140px;
        .box_item {
          display: flex;
          flex-direction: column;
          .box_title {
            width: 71px;
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 45px;
          }
          .box_line {
            width: 43px;
            height: 5px;
            background: #3986ff;
          }
          .box_span {
            width: 96px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #595961;
            line-height: 22px;
          }
        }
      }
      .custom_item_text {
        margin-left: 50px;
        .title {
          height: 40px;
          font-size: 22px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 40px;
        }
        .text {
          height: 20px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 20px;
          margin-top: 30px;
        }
      }
      img {
        width: 438px;
        height: 302px;
      }
    }
  }
}
.case {
  background: #f8fbff;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 1171px;
      height: 397px;
    }
  }
}

.banner {
  background: url("~@/assets/images/QcAssociation/banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  min-height: 420px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
        width: 520px;
        height: 66px;
        font-size: 48px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 66px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #ffffff;
      margin: 16px 0 31px;
    }
    .desc {
        width: 484px;
        height: 64px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 32px;
      .desc-content {
        width: 600px;
        height: 96px;
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 32px;
      }
    }
    .btn-wrap {
      display: flex;
      .btn {
        width: 200px;
        height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 58px;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
        margin-left:20px;
      }
      .btn1 {
        width: 200px;
        height: 58px;
        background: #07D19F;
        border-radius: 6px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        font-size: 22px;
        line-height: 58px;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
        //   margin-left:20px;
      }
    }
  }
}
</style>
